import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { Static } from 'core-components/types'
import { IFilter, IQueryResult } from 'core-components/types'
import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'
import {
  IExcCategory,
  IException,
} from 'onboarding/components/widgets/public/admin/exceptionsReasons/models'

export enum EExceptionRequestCrudKey {
  exceptionRequestList = 'exception-request-list',
  exceptionsList = 'ExceptionsList',
  exceptionCategoriesList = 'ExceptionCategoriesList',
  exceptionParentCategoriesList = 'ExceptionParentCategoriesList',
  domains = 'domains',
  dropdown = 'dropdown',
}

class ExceptionRequestApi {
  public getExceptionsCrud(
    type?: RequestTypes,
    crudKey?: EExceptionRequestCrudKey
  ): Crud<IException> {
    return type === RequestTypes.RetailException
      ? CrudStore.get<IException>(CrudStoreItemOnboarding.RetailExceptionsList, crudKey)
      : CrudStore.get<IException>(CrudStoreItemOnboarding.ExceptionsList, crudKey)
  }

  public getExceptionCategoriesCrud(
    type?: RequestTypes,
    crudKey?: EExceptionRequestCrudKey
  ): Crud<IExcCategory> {
    let crud = CrudStore.get(CrudStoreItemOnboarding.ExceptionsReasonsList, crudKey)
    if (type === RequestTypes.RetailException) {
      crud = CrudStore.get(CrudStoreItemOnboarding.RetailExceptionsReasonsList, crudKey)
    }

    return crud
  }

  public getActiveExceptions(
    type: RequestTypes,
    crudKey?: EExceptionRequestCrudKey
  ): Promise<IQueryResult<IException, any>> {
    const crud = this.getExceptionsCrud(type, crudKey)

    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'Active',
          value: 1,
          operator: Operator.EQUAL,
        },
      ],
    })

    crud.setPaging({ page: 0, pageSize: 1_000 })

    return crud.fetch()
  }

  public getTypeExceptionsCrud(type: RequestTypes, crudKey?: EExceptionRequestCrudKey) {
    const crud = this.getExceptionsCrud(type, crudKey)

    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'Type',
          operator: Operator.EQUAL,
          value: type,
        },
      ],
    })

    crud.setPaging({ page: 0, pageSize: 100 })

    return crud
  }

  public getEmptyExceptionsCrud() {
    return new Crud<IException>({
      fetcher: new Static([] as IException[]),
      keyField: 'Code',
    })
  }

  public getActiveExceptionsFilteredBy(
    type: RequestTypes,
    filter: Partial<IException>
  ): Crud<IException, any> {
    const crud = this.getExceptionsCrud(type, EExceptionRequestCrudKey.exceptionRequestList)

    const filters: IFilter[] = [
      {
        field: 'Active',
        value: 1,
        operator: Operator.EQUAL,
      },
    ]
    if (filter.Domain) {
      filters.push({
        field: 'Domain',
        operator: Operator.EQUAL,
        value: filter.Domain,
      })
    }
    if (filter.Group) {
      filters.push({
        field: 'Group',
        operator: Operator.EQUAL,
        value: filter.Group,
      })
    }

    crud.setFilter({
      logic: Logic.AND,
      filters,
    })
    crud.setPaging({
      page: 0,
      pageSize: 3000,
    })

    return crud
  }

  public getExceptionByCode(
    type: RequestTypes,
    code: string,
    needCache: boolean = false
  ): Promise<IException | null> {
    const crud = this.getExceptionsCrud(type)

    return crud.getById({ id: code, force: !needCache, keyField: 'Code' })
  }

  public getCategoriesCrudFilteredByExceptionCode({
    type,
    exceptionCode,
    isActive,
    crudKey,
  }: IGetCategoriesCrudFilteredByExceptionCodeParams) {
    const crud = this.getExceptionCategoriesCrud(type, crudKey)
    const filters: IFilter[] = [
      {
        field: 'ExceptionCode',
        operator: Operator.EQUAL,
        value: exceptionCode,
      },
    ]
    if (isActive) {
      filters.push({
        field: 'Active',
        operator: Operator.EQUAL,
        value: 1,
      })
    }
    crud.setFilter({
      logic: Logic.AND,
      filters,
    })
    crud.setPaging({
      page: 0,
      pageSize: 3000,
    })

    return crud
  }
}

export const exceptionRequestApi = new ExceptionRequestApi()

export interface IGetCategoriesCrudFilteredByExceptionCodeParams {
  type: RequestTypes
  exceptionCode: string
  crudKey: EExceptionRequestCrudKey
  isActive?: boolean
}
